
interface CityStatsProps {
  totalCities: number;
}

export function CityStats({ totalCities }: CityStatsProps) {
  return (
    <div className="text-sm text-muted-foreground">
      {totalCities} cities total
    </div>
  );
}
